export function cardsSlider() {
    let $cardHolder = $(".cards-list");

    $cardHolder.each( function () {
        let $th = $(this);

        if ($th.hasClass("cards-slider")) {
            $th.slick({
                slidesToShow: 1,
                slidesToScroll: 1,
                dots: true,
                arrows: false,
                infinite: false,
                mobileFirst: true,
                responsive: [
                    {
                        breakpoint: 568,
                        settings: {
                            slidesToShow: 2,
                        }
                    },
                    {
                        breakpoint: 768,
                        settings: {
                            slidesToShow: 3,
                        }
                    },
                    {
                        breakpoint: 1200,
                        settings: "unslick"
                    },
                ]
            });
        }
    });
}


// WEBPACK FOOTER //
// ./assets/js/modules/cardsSlider.js